export const dataHooks = {
  socialPreviewTitle: 'socialPreview-title',
  socialPreviewDescription: 'socialPreview-description',
  socialPreviewUrl: 'socialPreview-url',
};
